export default __webpack_public_path__ + "static/media/bg.d33d02c1.jpg";